import React from "react";
import "../styles.scss";
import { Text } from "@amzn/stencil-react-components/text";
import { Row } from "@amzn/stencil-react-components/layout";
import useArb from "../../../hooks/use-arb";
import { StatusContainer } from "./status-container";
import {
  getI9Status,
  ScreenResult,
} from "../../../utility/screening-results-helper";

import { ScreeningResultsControlledInput } from "../../screening-results/card-controlled";
import {
  Button,
  ButtonSize,
  ButtonIconPosition,
} from "@amzn/stencil-react-components/button";
import { ScreeningResultCompletedHeader } from "./screening-result-complete";
import { ScreeningResultErrorHeader } from "./screening-result-error";
import { ScreeningProcessHeader } from "./screening-result-process";
import { ProgressArc } from "@amzn/stencil-react-components/spinner";

interface Result {
  status: string;
}

export const ScreeningResultsProgressControlled = ({
  property,
}: ScreeningResultsControlledInput) => {
  const bundle = useArb("HVHChecklistPantherResource");

  const i9Status = !property.i9Response
    ? ScreenResult.Error
    : getI9Status(property.i9Response);
  const bgcStatus = !property.bgcResponse?.status
    ? ScreenResult.Error
    : property.bgcResponse.status;
  const dtStatus = !property.dtResponse?.status
    ? ScreenResult.Error
    : property.dtResponse.status;

  if (
    i9Status === ScreenResult.Complete &&
    bgcStatus === ScreenResult.Complete &&
    dtStatus === ScreenResult.Complete
  ) {
    return <ScreeningResultCompletedHeader />;
  }

  if (
    i9Status === ScreenResult.Pending &&
    bgcStatus === ScreenResult.Pending &&
    dtStatus === ScreenResult.Pending
  ) {
    return <ScreeningProcessHeader />;
  }

  if (
    i9Status === ScreenResult.Error ||
    bgcStatus === ScreenResult.Error ||
    dtStatus === ScreenResult.Error
  ) {
    return <ScreeningResultErrorHeader />;
  }

  const results = [
    {
      status: i9Status,
    },
    {
      status: bgcStatus,
    },
    {
      status: dtStatus,
    },
  ] as Array<Result>;

  const count = results
    .filter((result) => result.status === ScreenResult.Complete)
    .length.toString();
  const totalCount = results.length;

  const formattedProcessingScreenMsg = bundle.getMessage(
    "Checklist-AppointmentCard-Screen-Result"
  );
  const progressBtnText = bundle.getMessage(
    "Checklist-AppointmentCard-ButtonText6"
  );
  const totalTestCountText = bundle.getMessage(
    "Checklist-AppointmentCard-Screen-Test-Count"
  );

  return (
    <StatusContainer
      largeViewPortImage={require("./sandwatch.svg").default}
      smallViewPortImage={require("./sandwatch.svg").default}
    >
      <Text fontSize={"T400"} textAlign="center">
        {formattedProcessingScreenMsg}
      </Text>

      <Row gridGap={"1rem"}>
        <Text fontSize={"T200"}>
          {count + "/" + totalCount + " " + totalTestCountText}
        </Text>
      </Row>
      <Row>
        <Button
          size={ButtonSize.Small}
          icon={<ProgressArc />}
          iconPosition={ButtonIconPosition.Leading}
          onClick={() =>
            document.getElementById("screeningresult")?.scrollIntoView()
          }
        >
          {progressBtnText}
        </Button>
      </Row>
    </StatusContainer>
  );
};
